import Logo from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";

export default function Header() {
  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between gap-4 px-5 sm:px-8">
        <a
          href="#top"
          data-testid="header-logo"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <Logo light />
        </a>

        <div className="flex items-center gap-3">
          <button
            data-testid="support-help-button"
            onClick={() => scrollToSection("#connect")}
            className="rounded-full border-2 border-white px-5 py-2 text-xs font-bold text-white transition-colors duration-200 hover:bg-white hover:text-navy"
          >
            Need help?
          </button>
        </div>
      </div>
    </header>
  );
}
